import awsmobile from './aws-exports'

const awsconfig = {
  ...awsmobile,
  API: {
    endpoints: [{
      name: process.env.REACT_APP_REST_API_NAME,
      endpoint: process.env.REACT_APP_REST_API_ENDPOINT
    }, {
      name: process.env.REACT_APP_APP_LOG_REST_API_NAME,
      endpoint: process.env.REACT_APP_APP_LOG_REST_API_ENDPOINT
    }]
  },
  aws_pubsub_region: 'ap-southeast-1',
  aws_pubsub_endpoint: process.env.REACT_APP_WSS_IOT_ENDPOINT
};

export default awsconfig;